import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  align?: 'center' | 'left';
  tone?: 'dark' | 'light';
  as?: 'h2' | 'h3';
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  align = 'center',
  tone = 'dark',
  as: Tag = 'h2'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center items-center' : 'text-left items-start';
  const titleColor = tone === 'dark' ? 'text-plum' : 'text-cream';
  const introColor = tone === 'dark' ? 'text-ink/70' : 'text-cream/75';
  const eyebrowColor = tone === 'dark' ? 'text-clay' : 'text-blush';
  return <div className={`flex flex-col ${alignment}`} data-id="element-166" data-mp="1u0x5rhs3vd6">
      {eyebrow ? <span className={`mb-4 text-xs font-medium uppercase tracking-[0.28em] ${eyebrowColor}`} data-id="element-167" data-mp="6svc2icmkzs0">
          {eyebrow}
        </span> : null}
      <Tag className={`font-display text-3xl leading-[1.12] sm:text-4xl md:text-5xl ${titleColor}`} data-id="element-168" data-mp="z9xypx26sbpy">
        {title}
      </Tag>
      {intro ? <div className={`mt-5 max-w-2xl text-base leading-relaxed sm:text-lg ${introColor} ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-169" data-mp="1tah116mozkyu">
          {intro}
        </div> : null}
    </div>;
}